import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { Tabs } from "components";
import { usePermanentRealTimeUser } from "hooks";
import "modules/DealerLocationDetails/components/LocationDetailHeader/LocationDetailHeader.scss";
import { PATHS } from "router/paths";
import { isAdmin } from "utils/common";

import type { TabData } from "components";

type LocationDetailHeaderProps = {
  isUpdateLocationPending: boolean;
};

export const LocationDetailHeader = ({ isUpdateLocationPending }: LocationDetailHeaderProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { user } = usePermanentRealTimeUser();
  const isAdminUser = Boolean(user && isAdmin(user.role_id));

  const visibleTabs: [string, TabData][] = [
    ["general", { data: [], id: "general", title: t("v8_general", "General"), icon: <Icon className="gears" /> }],
    ["workorder", { data: [], id: "workorder", title: t("v8_workorder", "Workorder"), icon: <Icon className="eye" /> }],
    ["keylabelKeylocker", { data: [], id: "keylabelKeylocker", title: t("v8_keylabel_keylocker", "Keylabel & Keylocker"), icon: <Icon className="key" /> }],
    ["dmsSystem", { data: [], id: "dmsSystem", title: t("v8_dms_system", "DMS / System"), icon: <Icon className="cloud" /> }]
  ];

  if (isAdminUser)
    visibleTabs.push([
      "customerCommunication",
      { data: [], id: "customerCommunication", title: t("v8_customer_communication", "Customer Communication"), icon: <Icon className="comments" /> }
    ]);

  visibleTabs.push(
    ["service", { data: [], id: "service", title: t("v8_service", "Service"), icon: <Icon className="wrench" /> }],
    ["tyres", { data: [], id: "tyres", title: t("v8_tyres", "Tyres"), icon: <Icon className="tire" /> }]
  );

  if (isAdminUser)
    visibleTabs.push(
      ["integrations", { data: [], id: "integrations", title: t("v8_integrations", "Integrations"), icon: <Icon className="plug" /> }],
      ["aiTablet", { data: [], id: "aiTablet", title: t("v8_ai_and_tablet", "AI & Tablet"), icon: <Icon className="robot" /> }]
    );

  const tabs = new Map(visibleTabs);

  return (
    <div className="LocationDetailHeader">
      <div className="row center">
        <div className="full tabs">
          <Tabs data={tabs} />
        </div>
        <div className="actions">
          <Button type="button" basic onClick={() => history.push(PATHS.DEALERS_DASHBOARD)}>
            {t("v8_cancel", "Cancel")}
          </Button>
          <Button color="green" type="submit" disabled={isUpdateLocationPending} loading={isUpdateLocationPending}>
            {t("v8_save", "Save")}
            <Icon className="check" />
          </Button>
        </div>
      </div>
    </div>
  );
};
